import { useCallback, useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  InitiativesNameComponent,
  KebabTableMenuInitiatives,
  SimpleComponent,
} from 'screens/Initiatives/InitiativeAudit/AGGridComponents';

import { localStorageKeys } from 'constants/localStorageKeys';
import { sendOpenedKRPanelEvent } from 'constants/mixpanelHelper';

import { showTaskDetails } from 'services/taskDetails';

import { AgGridWrapper } from 'uiToolkitV1/AgGridWrapper';
import { TableBodyRow } from 'uiToolkitV1/TableComponents';

export const StyledInitiativeTableBodyRow = styled(TableBodyRow)(({ theme }) => ({
  '& .action': {
    display: 'none',
  },
  '&:hover': {
    cursor: 'pointer',
    '& .info': {
      display: 'none',
    },
    '& .action': {
      display: 'flex',
    },
    'td:first-of-type p': {
      // @ts-ignore
      color: theme.colors.text['1565BC'],
    },
  },
}));

export const getFlexJustifyFromCellAlign = (align) => {
  switch (align) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    default:
      return 'center';
  }
};

const defaultRowsPerPage = 10;

export const defaultRowsPerPageLSObject = {
  [localStorageKeys.rabbitInitiativeTableRowsPerPage]: defaultRowsPerPage,
};

const InitiativesAgGrid = ({ tableData, pageType = 'Home Page' }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const showDetails = (e, taskId, type) => {
    e?.stopPropagation();

    dispatch(
      // @ts-ignore
      showTaskDetails({
        taskIds: [taskId],
        onDelete: () => {},
        onUpdate: (task) => {},
        employee: {},
        type,
        history,
      })
    );

    sendOpenedKRPanelEvent({
      eventProperties: {
        source: pageType,
      },
    });
  };

  const handleViewDetails = ({ event, data, column }) => {
    if (column.colId !== '0') {
      const { uuid, type } = data;
      showDetails(event, uuid, type);
    }
  };

  const isProfilePage = pageType === 'Profile Page';

  const columnDefs = useMemo(() => {
    const columns = [
      {
        headerName: 'Initiatives',
        field: 'title',
        valueGetter: (data) => ({ title: data.data?.title, isCompleted: data.data?.completionTS !== null }),
        flex: 1,
        minWidth: 488,

        cellRenderer: InitiativesNameComponent,
      },
      {
        headerName: 'Owner',
        field: 'toIds',
        cellRenderer: SimpleComponent,
        width: 160,
      },
    ];
    if (!isProfilePage) {
      columns.push({
        field: '',
        // @ts-ignore
        maxWidth: 75,
        headerName: '',
        pinned: 'right',
        lockPosition: 'right',
        suppressHeaderMenuButton: true,
        cellClass: 'locked-col',
        cellRenderer: KebabTableMenuInitiatives,
        valueGetter: (data) => {
          const accessPrivilegesList = Array.isArray(data.data?.accessPrivileges)
            ? data.data?.accessPrivileges.map(({ name }) => name)
            : [];
          return accessPrivilegesList;
        },
        suppressColumnsToolPanel: true,
      });
    }
    return columns;
  }, [isProfilePage]);

  const getRowStyle = (params) => ({ cursor: 'pointer' });

  const getRowId = useCallback(({ data }) => data?.uuid, []);

  const gridStatePersistenceKey = null;

  return (
    <Box className="ag-theme-alpine" style={{ width: '100%' }}>
      <AgGridWrapper
        useFilterModelPersistence={false}
        useColumnStatePersistence={false}
        gridStatePersistenceKey={gridStatePersistenceKey}
        defaultColDef={{
          autoHeight: true,
          wrapText: true,
        }}
        // @ts-ignore
        columnDefs={columnDefs}
        rowData={tableData}
        domLayout="autoHeight"
        animateRows={false}
        //   @ts-ignore
        onCellClicked={handleViewDetails}
        getRowStyle={getRowStyle}
        rowHeight={60}
        getRowId={getRowId}
        headerHeight={0}
      />
    </Box>
  );
};

export { InitiativesAgGrid };
